import React from "react"
import { DropdownItem, Form, Message, TextArea } from "semantic-ui-react"
import BifrostButton from "../../../../../Components/BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../../../BifrostPageComponent/BifrostModal/BifrostModal"
import Loader from "../../../../BifrostPageComponent/Loader/Loader"
import { useEndOngoingSessionModal } from "../hooks/useEndOngoingSessionModal"
import { CONST_MAX_MESSAGE_LENGTH } from "../store/states"

const EndOngoingSessionModal = ({ chosenItem, refresh }) => {
	const { state, toggleModalHandler, inputMessageHandler, endSessionHandler, cancelHandler } = useEndOngoingSessionModal(chosenItem, refresh)

	return (
		<BifrostModal
			title={"End Ongoing Session"}
			closeOnEscape={true}
			closeOnDimmerClick={true}
			open={state.open}
			setOpen={toggleModalHandler}
			trigger={<DropdownItem icon="stop circle outline" text="End session" disabled={chosenItem.state !== "session"} />}
			modalPage={
				<>
					{state.isLoading && <Loader backgroundColor="white" inverted size="small" />}
					{state.isError && <Message negative content={state.errorMessage} />}
					{state.isSuccess && <Message positive content="Session ended successfully" />}
					{!(state.isLoading || state.isError || state.isSuccess) && (
						<>
							<p style={{ color: "black" }}>
								Are you sure you want to end <b>{chosenItem.shortname}</b>'s session?
								<br />
								<br />
								Please leave a message to the session:
							</p>
							<Form>
								<Form.Field error={state.isOverMaxMessageLength}>
									<TextArea
										placeholder={`Leave a message... (Optional)\n\nMax ${CONST_MAX_MESSAGE_LENGTH - state.message.length} characters`}
										onChange={(event, data) => inputMessageHandler(event, data)}
									/>
								</Form.Field>
							</Form>
						</>
					)}
				</>
			}
			modalActions={
				<>
					{!state.isError && (
						<BifrostButton color="red" disabled={state.isLoading || state.isOverMaxMessageLength} style={{ display: "inline-block" }} onClick={() => endSessionHandler()}>
							End Session
						</BifrostButton>
					)}
					<BifrostButton style={{ display: "inline-block", width: "8rem" }} color="gray" onClick={() => cancelHandler()} disabled={state.isLoading}>
						Cancel
					</BifrostButton>
				</>
			}
		/>
	)
}

export default EndOngoingSessionModal
